import { ValidationErrorMessages } from '../../types/controls-error';

export const ERROR_MESSAGES_VALUE: ValidationErrorMessages = {
  unknown: 'This field has an error',
  required: 'This field is required',
  email: 'Please enter a valid email'
};
export default ERROR_MESSAGES_VALUE;